import _ from 'lodash';
import { useMemo } from 'react';

const BackdropDemo = ({ backdrop, boothType = 'salsa' }) => {
  const renderedBackdrop = useMemo(() => {
    const extension = _.chain(backdrop).split('.').last().toLower().value();
    const isVideo = ['mp4', 'm4v', 'mov'].includes(extension);

    return (
      <>
        <div
          className="backdrop-demo-background-wrapper"
          style={{
            clipPath: 'url(#backdropPath)',
          }}
        >
          {isVideo ? (
            <video className="backdrop-demo-background-content" src={backdrop} />
          ) : (
            <img className="backdrop-demo-background-content" src={backdrop} />
          )}
        </div>
        <svg height={0} width={0}>
          <defs>
            <clipPath id="backdropPath" clipPathUnits="objectBoundingBox">
              <path d="M1,1 V0.065 h0 C1,0.029,0.973,0,0.94,0 c0,0,-0.001,0,-0.001,0 v0 H0.06 C0.027,0,0,0.029,0,0.065 v0.934 H1" />
            </clipPath>
          </defs>
        </svg>
      </>
    );
  }, [backdrop]);

  const boothImage = useMemo(() => {
    if (boothType === 'guac') {
      return <img alt="Guac booth" className="backdrop-demo__booth" src="/static/booth/guac-front.png" />;
    }
    return <img alt="Salsa booth" className="backdrop-demo__booth" src="/static/booth/salsa2-back.png" />;
  }, [boothType]);

  return (
    <div className="backdrop-demo">
      {renderedBackdrop}
      {boothImage}
    </div>
  );
};

export default BackdropDemo;
